import { Component, OnInit } from "@angular/core";
import { UsersService } from "../../services/users.service";
import { ActivatedRoute } from "@angular/router";
import AppConstants from "../../constants/AppConstants";

@Component({
  selector: "app-users",
  templateUrl: "./users.component.html",
  styleUrls: ["./users.component.scss"],
})
export class UsersComponent {
  count: number;
  users = [];
  searchQuery = "";
  readonly DEFAULT_PAGE_SIZE = AppConstants.DEFAULT_PAGE_SIZE;
  readonly DEFAULT_PAGE_SIZE_OPTIONS = AppConstants.DEFAULT_PAGE_SIZE_OPTIONS;
  readonly DEFAULT_PAGINATION_INFO = { pageIndex: 0, pageSize: 10 };
  pageIndex = 0;
  pageCursors: any[] = [];
  currentPageSize = 10;

  constructor(
    private graphqlService: UsersService,
    private route: ActivatedRoute,
  ) {
    route.params.subscribe((val) => {
      this.fetchList(this.DEFAULT_PAGINATION_INFO);
    });
  }

  pageChanged({ pageIndex, pageSize }) {
    this.fetchList(
      {
        pageIndex,
        pageSize,
      },
      this.searchQuery,
    );
  }

  search(input) {
    this.pageIndex = 0;
    this.pageCursors = [];
    this.fetchList({ pageIndex: 0, pageSize: this.currentPageSize }, input);
  }

  private fetchList(pageInfo, searchParam?: string) {
    this.pageIndex = pageInfo.pageIndex;
    const cursorForPage = this.pageIndex > 0 ? this.pageCursors[this.pageIndex - 1] : undefined;
    const obj = {
      paginationData: {
        pageIndex: pageInfo.pageIndex,
        pageSize: pageInfo.pageSize,
        next: cursorForPage,
      },
      searchParam: searchParam,
    };
    this.graphqlService.list(obj).subscribe((result) => {
      console.log(result, "user results");
      if (result && result.data) {
        this.users = result.data["users"].edges.map((edge) => edge.node);
        this.count = result.data["users"].totalCount;
        this.pageCursors[this.pageIndex] = result.data["users"].pageInfo;
      }
      
    });
  }
}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/components/users/users.component.ts